import React, {useState} from 'react';
import {Pressable, Text} from 'react-native';
import {fontFamily} from '../../../helpers/fontFamily';
import {
  dangerColor,
  textColor,
  textMutedColor,
  toggleOffColor
} from '../../../style/adminTools';
import {TooltipAnchor, TooltipBubble} from './TooltipTarget';

const ActionButton = ({label, enabled, reason, onPress, danger, testID}) => {
  const [tipOpen, setTipOpen] = useState(false);
  const showTip = !enabled && tipOpen;
  let labelColor = textMutedColor;
  if (enabled) labelColor = danger ? dangerColor : textColor;

  return (
    <TooltipAnchor>
      <Pressable
        testID={testID}
        accessibilityRole="button"
        accessibilityState={{disabled: !enabled}}
        onPress={() => (enabled ? onPress() : setTipOpen(open => !open))}
        onHoverIn={() => setTipOpen(true)}
        onHoverOut={() => setTipOpen(false)}
        onBlur={() => setTipOpen(false)}
        style={{
          height: 36,
          minWidth: 44,
          paddingHorizontal: 14,
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: 6,
          borderWidth: 2,
          borderColor: enabled && danger ? dangerColor : toggleOffColor,
          opacity: enabled ? 1 : 0.5
        }}
      >
        <Text
          style={{
            fontFamily: fontFamily.font600,
            fontSize: 13,
            color: labelColor
          }}
        >
          {label}
        </Text>
      </Pressable>
      {showTip ? (
        <TooltipBubble testID={`${testID}Tip`} text={reason} align="right" />
      ) : null}
    </TooltipAnchor>
  );
};

export default ActionButton;
